import type { Attributes } from "@flareapp/js";

type FlareReporter = {
  report: (error: Error, context?: Attributes) => void | Promise<void>;
};

type ReportFailureHandler = (error: unknown) => void;

const logReportFailure: ReportFailureHandler = (error) => {
  console.warn("Failed to report error to Flare:", error);
};

export function safelyReportToFlare(
  reporter: FlareReporter,
  error: Error,
  context?: Record<string, unknown>,
  onFailure: ReportFailureHandler = logReportFailure,
): void {
  try {
    // Flare's runtime serializer accepts diagnostic objects more broadly than
    // its public AttributeValue type and safely truncates unsupported depth.
    const report = reporter.report(error, context as Attributes | undefined);
    void Promise.resolve(report).catch(onFailure);
  } catch (reportError) {
    onFailure(reportError);
  }
}
